export default "__VITE_ASSET__t3sNGIY5__"